import { schema } from 'normalizr';

const user = new schema.Entity('user');
// Define a comments schema
const comment = new schema.Entity('comments', { author: user });

// Define a reviews
const reviews = new schema.Entity(
  'reviews',
  {
    author: user,
    comments: [comment],
  },
  { idAttribute: 'id' }
);

//  Define a list of  reviews extracted from an array of reviews
export const reviewListSchema = [reviews];

export const placeSchema = new schema.Entity('place');

const theme = new schema.Entity('themes');
export const themeSchema = [theme];

export const lodge = new schema.Entity('lodges'); //For single lodge
export const lodgeSchema = [lodge]; //For lists of lodge

export const lodgeDetail = new schema.Entity('lodgeDetail', {}, { idAttribute: 'id' });
export const lodgeDetailSchema = lodgeDetail;

const sidetrip = new schema.Entity('sidetrips');
export const sidetripSchema = [sidetrip];

const flights = new schema.Entity('flights');
export const flightsSchema = [flights];

const place = new schema.Entity('places');
export const placeListSchema = [place];

// Define a user schema
export const userSchema = [user];

const treks = new schema.Entity('treks', {}, { idAttribute: 'id' });
export const treksSchema = [treks];



// WEBPACK FOOTER //
// ./src/redux/Schema.js